import { PropsWithChildren } from "react";
import { TooltipContext, TooltipContextValue } from "./TooltipContext";

export function TooltipProvider({
  children,
  ...props
}: PropsWithChildren<TooltipContextValue>) {
  return (
    <TooltipContext.Provider value={props}>{children}</TooltipContext.Provider>
  );
}
